import React, {  useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Typography
} from '@mui/material';
import { Button } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { useIntl } from 'react-intl'

//actions
import {
    clearRedux,
    alertsOpenDeleteModal,
    deleteAlerts
} from 'Redux/actions';

const DeleteTab = ({pagination}) => {
    const dispatch = useDispatch();
    const { messages } = useIntl()


    const {
        isOpenModalDeleteAlerts: open,
        selectedAlertsDeleted: items,
        loading
    } = useSelector(state => state.alertsTabRedux);


    const onSubmit = () => {
        dispatch(deleteAlerts(
            items,
            messages["alertsTabView_successAlertDeletion"],
            messages["alertsTabView_failedAlertDeletion"],
        ));
    }


    const handleClose = useCallback(() => {
        dispatch(alertsOpenDeleteModal(false));
        dispatch(clearRedux("ALERTS_TAB", {
            isOpenModalDeleteAlerts: false,
            loading: false,
            selectedAlertsDeleted:[]
        }));
    });

    return (
        <Modal
            title={messages['alertsTabView_deleteAlertTitle']}
            open={open}
            loading={loading}
            position="right"
            size="small"
            handleClose={handleClose}
        >
            <ModalBody>
                <div style={{ padding: 24, height: 450 }}>

                    <Typography
                        variant="subtitle2"
                        color="textSecondary"
                    >
                        {messages['alertsTabView_deleteAlertContent']}
                    </Typography>
                    <div style={{ marginTop: 24 }}>
                        {
                            (items && items?.length) &&
                            <ul>
                                {
                                    items.map((item, key) => {
                                        return (
                                            <li key={key}>
                                                {item?.name}
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        }
                    </div>
                </div>
            </ModalBody>

            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button
                    disabled={loading}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loading}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        onSubmit();
                        pagination?.onSearchText("")
                    }}
                    className="btn-red"
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default DeleteTab;